function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ALL_TABLES_OPTION, textsDefaul } from '@/js/constants';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
export default {
  name: 'SearchBusinessTerm',
  props: {
    placeholder: {
      type: String,
      required: false,
      default: 'Search by business term ...'
    },
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    filter: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      collapse_filter: false,
      messageEmptyList: textsDefaul.LOADING,
      query: '',
      showOptions: false,
      select_domain: null,
      list_env: [{
        value: null,
        text: 'All'
      }, {
        value: 'dev',
        text: 'Development'
      }, {
        value: 'test',
        text: 'Test'
      }],
      criteria: {
        name: '',
        path_name: '',
        column_name: '',
        data_operator: '',
        env: null
      },
      items: []
    };
  },
  computed: {
    businessTermFields: function businessTermFields() {
      return [{
        key: '↕',
        variant: 'return-sort'
      }, {
        label: this.traductor('tablas.bterm'),
        key: 'business_term',
        sortable: true,
        class: 'text-left font-weight-bold'
      }, {
        label: this.traductor('tablas.definition'),
        key: 'definition',
        sortable: true,
        class: 'text-left'
      }, {
        label: this.traductor('tablas.values'),
        key: 'values',
        sortable: true,
        class: 'h6'
      }, {
        label: this.traductor('tablas.creation_time'),
        key: 'update_date',
        sortable: true
      }, _defineProperty({
        label: this.traductor('tablas.actions'),
        key: 'actions',
        class: ['pr-1', 'pl-1']
      }, "label", '')];
    },
    get_list_domains: function get_list_domains() {
      var list_domains = [];
      if (this.showDomains) {
        list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
        list_domains.unshift(window.userInfo.domain);
        list_domains.unshift(ALL_TABLES_OPTION);
      } else {
        list_domains.unshift(window.userInfo.domain);
      }
      return list_domains;
    }
  },
  watch: {
    select_domain: function select_domain() {
      this.onSearch();
    }
  },
  created: function created() {
    if (this.defaultDomain == null) {
      this.select_domain = window.userInfo ? window.userInfo.domain : null;
    } else {
      this.select_domain = this.defaultDomain;
    }
    this.query = this.filter;
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSearch: function onSearch() {
      var _this = this;
      var params = {
        domain: this.select_domain,
        clauses: {
          accountable: window.userInfo.email
        }
      };
      businessTermService.getBusinessTerms(params).then(function (response) {
        if (response.data && response.data.result) {
          _this.items = response.data.result;
        } else {
          _this.messageEmptyList = textsDefaul.NOT_FOUND;
        }
      });
    },
    openBusinessTerm: function openBusinessTerm(business) {
      this.$router.push({
        path: "/BusinessTerm/".concat(this.select_domain, "/").concat(business.item.kbusiness_term)
      });
    }
  }
};